import React, {useContext} from "react";
import {ISaveAllController} from "./use-save-all-controller";

export const SaveAllControllerContext = React.createContext<ISaveAllController | undefined>(undefined)

export const useSaveAllControllerContext = () => useContext(SaveAllControllerContext);



